import request from 'utils/request'

import { MCBOS030UpdateRequest } from 'types/MCBOS030/MCBOS030UpdateRequest'
import { MCBOS030DeleteRequest } from 'types/MCBOS030/MCBOS030DeleteRequest'
import { MCBOS030InitRequest } from 'types/MCBOS030/MCBOS030InitRequest'


export const getUpdateInitialValuesApi = (param: MCBOS030InitRequest) =>
    request({
        url: 'MCBOS030/init/',
        method: 'post',
        data: param
    })

export const doUpdateApi = (param: MCBOS030UpdateRequest) =>
  request({
    url: 'MCBOS030/update',
    method: 'post',
    data: param,
})

export const doDeleteApi = (param: MCBOS030DeleteRequest) =>
  request({
    url: 'MCBOS030/delete',
    method: 'post',
    data: param,
})